module.exports = __webpack_public_path__ + "static/media/21ECLAC11.a5e6dc06.jpg";